'use strict';
(function () {
  // Embedded in the store homepage, #gk-lp2 bounds every query so theme links are left alone,
  // and data-key-events="theme" leaves LINE/phone key events to the theme's own listener.
  const root = document.getElementById('gk-lp2') || document;
  const cfg = root.dataset || {};
  const lpId = cfg.lpId || 'kampo_soudan_lp2';
  const themeKeyEvents = cfg.keyEvents === 'theme';

  // Menu
  const menuBtn = document.getElementById('menuBtn');
  const menu = document.getElementById('spMenu');
  if (menuBtn && menu) {
    const setMenu = open => {
      menuBtn.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    };
    menuBtn.addEventListener('click', () => setMenu(menuBtn.getAttribute('aria-expanded') !== 'true'));
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !menu.hidden) { setMenu(false); menuBtn.focus(); } });
  }

  // FAQ tabs
  const tabs = [...root.querySelectorAll('.faq-tabs [role="tab"]')];
  tabs.forEach(tab => tab.addEventListener('click', () => {
    tabs.forEach(t => t.setAttribute('aria-selected', String(t === tab)));
    root.querySelectorAll('.faq-panel').forEach(p => { p.hidden = p.dataset.panel !== tab.dataset.tab; });
  }));

  // Voice slider
  const track = document.getElementById('voiceTrack');
  const count = document.getElementById('voiceCount');
  if (track) {
    const items = [...track.children];
    const index = () => Math.round(track.scrollLeft / (track.clientWidth || 1));
    track.addEventListener('scroll', () => { count.textContent = String(Math.min(items.length, index() + 1)); }, { passive: true });
    root.querySelectorAll('.vs-arrow').forEach(btn => btn.addEventListener('click', () => {
      const next = (index() + Number(btn.dataset.dir) + items.length) % items.length;
      track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
    }));
  }

  // Hide the fixed bar while an in-page CTA is on screen.
  const fixed = document.getElementById('fixedCta');
  if (fixed && 'IntersectionObserver' in window) {
    const onScreen = new Set();
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => e.isIntersecting ? onScreen.add(e.target) : onScreen.delete(e.target));
      fixed.classList.toggle('is-hidden', onScreen.size > 0);
    });
    root.querySelectorAll('.js-cta, .site-footer .f-line').forEach(el => io.observe(el));
  }

  // Attribution: same routing as the current LP (ChatBoost LIFF route keeps rid).
if(window.GKTracking){window.GKTracking.start();return;}
  const sourceMap = {
    ig: { source: 'instagram', rid: 7 }, tiktok: { source: 'tiktok', rid: 27 }, threads: { source: 'threads', rid: 18 },
    x: { source: 'x', rid: 15 }, pinterest: { source: 'pinterest', rid: 19 }, substack: { source: 'substack', rid: 17 },
    note: { source: 'note', rid: 16 }, yt: { source: 'youtube', rid: 20 }, ig_story: { source: 'instagram', rid: 23 }
  };
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  const params = new URLSearchParams(location.search);
  let src = params.get('src');
  try {
    if (src && sourceMap[src]) sessionStorage.setItem('gk_lp_src', src);
    else src = sessionStorage.getItem('gk_lp_src');
  } catch (_) {}
  if (!sourceMap[src]) src = '';
  const attr = { src };
  keys.forEach(k => {
    let v = params.get(k);
    try { if (v) sessionStorage.setItem('gk_lp_' + k, v); else v = sessionStorage.getItem('gk_lp_' + k); } catch (_) {}
    if (v) attr[k] = v;
  });
  if (src && !attr.utm_source) attr.utm_source = sourceMap[src].source;
  const lineRid = src ? sourceMap[src].rid : 11;
  root.querySelectorAll('a[href*="lin.ee/"]').forEach(a => { a.href = 'https://line.me/R/app/2007178760-W2oQLzjq?rid=' + lineRid; });
  root.querySelectorAll('a[href*="res.locaop.jp/"]').forEach(a => {
    const url = new URL(a.href);
    if (attr.utm_source) {
      keys.forEach(k => { if (attr[k]) url.searchParams.set(k, attr[k]); });
      if (src) url.searchParams.set('src', src);
    }
    a.href = url.href;
  });

  const publish = (name, extra) => {
    const payload = { lp_id: lpId, traffic_source: attr.utm_source || 'direct', traffic_medium: attr.utm_medium || '(none)', traffic_campaign: attr.utm_campaign || '(not set)', ...extra };
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag === 'function') window.gtag('event', name, payload);
    else window.dataLayer.push({ event: name, ...payload });
  };
  publish('lp_view', { page_type: cfg.pageType || 'kampo_consult_lp2' });
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href]');
    if (!a || !root.contains(a)) return;
    const url = new URL(a.href, location.href);
    let type;
    if (url.hostname === 'line.me' || url.hostname === 'lin.ee') type = 'line';
    else if (url.hostname === 'res.locaop.jp') type = 'booking';
    else if (url.protocol === 'tel:') type = 'phone';
    if (!type) return;
    const section = a.closest('section');
    const position = a.closest('.fixed-cta') ? 'fixed' : a.closest('.site-header') ? 'header' : a.closest('.site-footer') ? 'footer' : section?.id || section?.className.split(' ')[0] || 'cta';
    const common = { cta_type: type, cta_position: position };
    publish('lp_cta_click', common);
    if (themeKeyEvents) return;
    if (type === 'line') publish('line_add_click', { ...common, line_rid: String(lineRid) });
    else if (type === 'booking') publish('booking_start', common);
    else publish('phone_click', common);
  });
})();
